import { ApiServiceV1 } from '@services/api.service';

export default {
  async getPressSheet({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/press-sheet/${id}/details`);
    return data || {};
  },

  async getPressSheetHistory({ suffix, id }) {
    const { data } = await ApiServiceV1.get(`${suffix}/press-sheet/${id}/history`);
    return data || [];
  },

  async getPressSheets({
    state = null, outerId = null,
    suffix, pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/press-sheet`, {
      params: {
        outerId,
        state,
        pageNum,
        pageSize,
      },
    });
    return data || {};
  },

  progressPressSheet({ suffix, id, ...data }) {
    return ApiServiceV1.post(`${suffix}/press-sheet/${id}/transition/progress`, { ...data });
  },

  revertPressSheet({ suffix, id, ...data }) {
    return ApiServiceV1.post(`${suffix}/press-sheet/${id}/transition/revert`, { ...data });
  },
};
